export default __webpack_public_path__ + "img/list2.e45ba4fe.jpg";